import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import linearGradient from "assets/theme/functions/linearGradient";

export default styled(Typography)(({ theme, ownerState }) => {
  const { palette, typography } = theme;
  const {
    color,
    textTransform,
    verticalAlign,
    fontWeight,
    opacity,
    textGradient,
  } = ownerState;

  const { gradients, transparent } = palette;
  const {
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold,
  } = typography;

  // fontWeight styles
  const fontWeights = {
    light: fontWeightLight,
    regular: fontWeightRegular,
    medium: fontWeightMedium,
    bold: fontWeightBold,
  };

  // styles for the typography with textGradient={true}
  const gradientStyles = () => {
    const isValidColor =
      color !== "inherit" && color !== "text" && color !== "white";
    const colorGradient = gradients && gradients[color];
    const darkGradient = gradients && gradients.dark;

    let backgroundImageValue;
    if (
      isValidColor &&
      colorGradient &&
      colorGradient.main &&
      colorGradient.state
    ) {
      backgroundImageValue = linearGradient(
        colorGradient.main,
        colorGradient.state
      );
    } else if (darkGradient && darkGradient.main && darkGradient.state) {
      backgroundImageValue = linearGradient(
        darkGradient.main,
        darkGradient.state
      );
    }

    return {
      backgroundImage: backgroundImageValue,
      display: "inline-block",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: transparent?.main || "transparent",
      position: "relative",
      zIndex: 1,
    };
  };

  return {
    opacity,
    textTransform,
    verticalAlign,
    textDecoration: "none",
    color:
      color === "inherit" || !palette[color] ? "inherit" : palette[color].main,
    fontWeight: fontWeights[fontWeight] && fontWeights[fontWeight],
    ...(textGradient && gradientStyles()),
  };
});
